import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { setOperationStatusSchema } from '../../../../shared/validators/schemas/set-operation-status.schema';
import { checkInOutActionValidationSchema } from '../../../shared/validators/schemas/check-in-out-validation.schema';
import { VehicleMaintenanceRecordDto } from '../../dtos/vehicle-maintenance-record.dto';
import { VehicleMaintenanceActionEnum } from '../../enums/vehicle-maintenance-action.enum';
import { VehicleMaintenanceStatusEnum } from '../../enums/vehicle-maintenance-status.enum';

/**
 * Validates if an action can be performed by validating the record data.
 * @param record - The record for the data validation.
 * @param action - The action to be validated.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canPerformAction = (
	record: VehicleMaintenanceRecordDto,
	action: VehicleMaintenanceActionEnum,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	switch (action) {
		case VehicleMaintenanceActionEnum.APPROVE:
			// TODO: Approval flow
			break;

		case VehicleMaintenanceActionEnum.REJECT:
			// TODO: Approval flow
			break;

		case VehicleMaintenanceActionEnum.CANCEL:
			validationResult = setOperationStatusSchema(
				VehicleMaintenanceStatusEnum.CANCELLED,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleMaintenanceActionEnum.COMPLETE:
			validationResult = setOperationStatusSchema(
				VehicleMaintenanceStatusEnum.COMPLETED,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleMaintenanceActionEnum.PENDING:
			validationResult = setOperationStatusSchema(
				VehicleMaintenanceStatusEnum.PENDING,
			).validate(record, {
				abortEarly,
			});
			break;

		case VehicleMaintenanceActionEnum.IN_PROGRESS:
			break;

		case VehicleMaintenanceActionEnum.CHECK_IN:
		case VehicleMaintenanceActionEnum.CHECK_OUT:
			validationResult = checkInOutActionValidationSchema().validate(record, {
				abortEarly,
			});
			break;

		default:
			throw new Error(`Unknown action: ${action}`);
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
